import { isLocalhost } from "./isLocalhost";

function isSessionStorageEnabled() {
  try {
    const key = `__storage__test`;
    window.sessionStorage.setItem(key, null);
    window.sessionStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

function isLocalStorageEnabled() {
  try {
    const key = `__storage__test`;
    window.localStorage.setItem(key, null);
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

function getStorageArea() {
  if (isLocalhost && isLocalStorageEnabled()) {
    return localStorage;
  }
  if (isSessionStorageEnabled()) {
    return sessionStorage;
  }

  if (isLocalStorageEnabled()) {
    return localStorage;
  }

  // just implement our own in-memory storage

  const fallbackStorage = {};

  const getItem: Storage["getItem"] = (key) => {
    return fallbackStorage[key + ""] ?? null;
  };

  const setItem: Storage["setItem"] = (key, value) => {
    fallbackStorage[key + ""] = value + "";
  };

  return { getItem, setItem };
}

export const storageArea = getStorageArea();
